export type SyncStatus = 'idle' | 'syncing' | 'offline' | 'error';

let currentStatus: SyncStatus = 'idle';
const listeners = new Set<(s: SyncStatus) => void>();

export function setSyncStatus(s: SyncStatus) {
  currentStatus = s;
  for (const fn of listeners) fn(s);
}
export function getSyncStatus(): SyncStatus { return currentStatus; }
export function subscribeSyncStatus(fn: (s: SyncStatus) => void): () => void {
  listeners.add(fn);
  return () => { listeners.delete(fn); };
}

export function renderSyncIndicator(root: HTMLElement): () => void {
  const update = () => {
    const labels: Record<SyncStatus, string> = {
      idle: '同期済',
      syncing: '同期中',
      offline: 'オフライン',
      error: '同期失敗',
    };
    root.innerHTML = `
      <span class="sync-indicator sync-indicator--${currentStatus}" role="status">
        <span class="sync-indicator__dot" aria-hidden="true"></span>
        <span class="sync-indicator__label">${labels[currentStatus]}</span>
      </span>
    `;
  };
  update();
  return subscribeSyncStatus(update);
}
